import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GatewayImportExportService} from '@services/administration/gateway/import-export/gateway-import-export.service';

@Component({
    selector: 'scitis-gateway-aliases-action',
    templateUrl: './gateway-aliases-action.component.html',
    styleUrls: ['./gateway-aliases-action.component.scss'],
    standalone: false
})
export class GatewayAliasesActionComponent {

  @Input()
  superOrTechAdminRole: boolean = false;

  @Input()
  isEditable: boolean = false;

  @Input()
  signalConfig: any = null;

  @Output()
  updatedConfig = new EventEmitter<any>();

  @Output()
  fileSelectEvent = new EventEmitter<Event>();

  @Output()
  openMaskEmit = new EventEmitter<boolean>();

  @Output()
  deleteAliasEmit = new EventEmitter<boolean>();

  @Output()
  showFull = new EventEmitter<boolean>();

  public name: string = '';
  public jsonType: string = '';

  constructor(
    private importExportService: GatewayImportExportService
  ) { }

  public onImportConnectorConfig(): void {
    this.updatedConfig.emit();
  }

  public onFileSelected(event: Event): void {
    this.fileSelectEvent.emit(event);
  }

  public onClickFileInput(input: any) {
    input.value = null;
  }

  public preventDefault(clickEvent: Event): void {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
  }

  public onExportConnectorConfig(): void {
    const filename = this.importExportService.createFilename(this.signalConfig);
    const details = this.importExportService.generateExportDetails(this.signalConfig);

    const hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/json;charset=utf-8,' + encodeURI(details);
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();
  }

  public openMask(): void {
    this.openMaskEmit.emit();
  }

  public onDeleteAlias(): void {
    this.deleteAliasEmit.emit();
  }
}
